module.exports = __webpack_public_path__ + "../panel-assets/img/FinHubLogoStopka.ff4e837e.svg";